import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { useState } from "react";
import { Box, CssBaseline, Drawer, List, ListItem, ListItemText, Toolbar, Typography, AppBar, IconButton, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import UploadInvoices from "./pages/UploadInvoices";
import { AuthProvider } from './contexts/FirebaseAuthContext';
import Connections from './components/Connections';

const drawerWidth = 240;
const logoImage = "/Ergoman.png";

const PrivateRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  if (loading) return <p>Loading...</p>;
  return user ? children : <Navigate to="/login" />;
};

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box sx={{ width: drawerWidth }} role="presentation">

      <Box component="img" src={logoImage} alt="Logo" sx={{ width: 150, m: 2 }} />


      <List>
        <ListItem button component="a" href="/dashboard">
          <ListItemText primary="Dashboard" />
        </ListItem>
        
        <ListItem button component="a" href="/upload">
          <ListItemText primary="Upload Invoices" />
        </ListItem>

        <ListItem button component="a" href="/connections">
          <ListItemText primary="Connections" />
        </ListItem>

        <ListItem button component="a" href="/upload">
          <Button variant="contained" color="error" onClick={() => auth.signOut()}>Sign Out</Button>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }} >
      <CssBaseline />
      <AppBar position="fixed" sx={{ width: { sm: `calc(100% - ${drawerWidth}px)` }, ml: { sm: `${drawerWidth}px` } }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2, display: { sm: "none" } }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 }}}>
        <Drawer variant="temporary" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{ keepMounted: true }}
          sx={{ display: { xs: "block", sm: "none" }, "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth } }}>
          {drawer}
        </Drawer>
        <Drawer variant="permanent" sx={{ display: { xs: "none", sm: "block" }, "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth } }} open>
          {drawer}
        </Drawer>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
          <Route path="/upload" element={<PrivateRoute><Layout><UploadInvoices /></Layout></PrivateRoute>} />
          <Route path="/connections" element={<PrivateRoute><Layout><Connections /></Layout></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
